import type { ApiClientConfig } from './types'
import { http } from './http'

export const apiClient = {
  get: <T>(url: string, config: Omit<ApiClientConfig, 'data'> = {}) => {
    // For GET requests, ensure we don't send unnecessary headers that trigger preflight
    const optimizedConfig = {
      ...config,
      headers: {
        // Only include essential headers for GET requests
        ...(config.headers && Object.keys(config.headers).length > 0
          ? config.headers
          : {}),
      },
    }
    return http<T>(url, { method: 'GET', ...optimizedConfig })
  },

  post: <T>(url: string, data?: unknown, config: ApiClientConfig = {}) => {
    return http<T>(url, { method: 'POST', data, ...config })
  },

  put: <T>(url: string, data?: unknown, config: ApiClientConfig = {}) => {
    return http<T>(url, { method: 'PUT', data, ...config })
  },

  patch: <T>(url: string, data?: unknown, config: ApiClientConfig = {}) => {
    return http<T>(url, { method: 'PATCH', data, ...config })
  },

  delete: <T>(url: string, config: ApiClientConfig = {}) => {
    // For DELETE requests, ensure we don't send unnecessary headers
    const optimizedConfig = {
      ...config,
      headers: {
        // Only include essential headers for DELETE requests
        ...(config.headers && Object.keys(config.headers).length > 0
          ? config.headers
          : {}),
      },
    }
    return http<T>(url, { method: 'DELETE', ...optimizedConfig })
  },
}
